import React from "react";

export const ServicesDetailsFaq = ({ items = [], idPrefix = "service-faq" }) => {
  return (
    <div className="accordion-wrap-three">
      <div className="accordion" id={`${idPrefix}-accordion`}>
        {items.map((item, index) => {
          const collapseId = `${idPrefix}-collapse-${index}`;
          const isOpen = Boolean(item.open);

          return (
            <div className="accordion-item" key={collapseId}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button${isOpen ? "" : " collapsed"}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={isOpen}
                  aria-controls={collapseId}
                >
                  {item.question}
                </button>
              </h2>
              <div
                id={collapseId}
                className={`accordion-collapse collapse${isOpen ? " show" : ""}`}
                data-bs-parent={`#${idPrefix}-accordion`}
              >
                {item.answer ? (
                  <div className="accordion-body">
                    <p>{item.answer}</p>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
